// extracted by mini-css-extract-plugin
export default {"symbolSearchContainer":"SymbolSearch_symbolSearchContainer__VO+U6"};